module.exports = __webpack_public_path__ + "static/media/PAGGOR-black.7109d661.svg";